<template>

	<div class="news container-fluid theme-light-gray">
		
		<TitleHeader :subtitle="subtitle" :title="title"></TitleHeader>

		<div class="container">

			<div class="news-full" :key="item.id" v-for="item in fullWidthNewsItems">
				<NewsItem :newsItem="item" :layout="'wide'"></NewsItem>
			</div>

			<div class="news-half">
				<NewsItem :newsItem="item" :layout="'half'" :key="item.id" v-for="item in halfWidthNewsItems"></NewsItem>
			</div>

			<div class="news-mini">
				<NewsItem :newsItem="item" :layout="'mini'" :key="item.id" v-for="item in miniNewsItems"></NewsItem>
			</div>
		</div>
	
		<PrimaryButton class="center" v-if="cta" :linkText="cta.linkText" :linkURL="cta.linkURL"></PrimaryButton>
		
	</div>
	
</template>

<script>

	import NewsItem from './NewsItem.vue';
	import TitleHeader from '../Global/TitleHeader.vue';
	import PrimaryButton from '../Global/PrimaryButton.vue';
	
	export default {
		name: 'News',
		
		props: ['subtitle', 'title', 'fullWidthNewsItems', 'halfWidthNewsItems', 'miniNewsItems', 'cta'],
		
		components: {
			TitleHeader,
			PrimaryButton,
			NewsItem
		}
	}
	
</script>